export default __webpack_public_path__ + "static/media/9.aae36d11.png";